import { render } from "./ValueFromRegExForm.vue?vue&type=template&id=171ea15a&ts=true"
import script from "./ValueFromRegExForm.vue?vue&type=script&lang=ts"
export * from "./ValueFromRegExForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__